import React from "react";
import { FaTimes } from "react-icons/fa";
import "./AboutUs.css";

const AboutUs = ({ onClose }) => {
  return (
    <aside className="about-us-panel">
      <button className="close-button" onClick={onClose}>
        <FaTimes />
      </button>
      <div className="about-content">
        <h2>Sobre nosotros</h2>
        <p>
          Somos un grupo de medios de comunicación con la misión de satisfacer los gustos e intereses de los oyentes a nivel mundial y conectarlos con sus raíces culturales, especialmente a aquellos compueblanos del sur y del municipio de Vicente Noble en la República Dominicana.
        </p>

        <h2>Nuestros Gerentes</h2>
        <div className="managers">
          <div className="manager">
            <img
              src="2.webp"
              alt="Jony Jairo Terrero Feliz"
              className="manager-image"
            />
            <div className="manager-info">
              <h3>Natanael Terrero Feliz</h3>
              <p>
                Director General, con más de 10 años en los medios de comunicación y con formación en ingeniería electrónica y comunicación en la radio, la televisión y los medios escritos.
              </p>
            </div>
          </div>
          <div className="manager">
            <img
              src="1.webp"
              alt="Natanael Terrero Feliz"
              className="manager-image"
            />
            <div className="manager-info">
              <h3>Jony Jairo Terrero Feliz</h3>
              <p>
                Director de Programación, con más de 20 años de experiencia en la Radio Dominicana y graduado en Locución.
              </p>
            </div>
          </div>
        </div>

        <h2>Nuestro Grupo de Medios</h2>
        <ul className="media-list">
          <li>
            <strong>Radio Noble 94.3 FM:</strong> Transmitiendo para toda el área de Vicente Noble y pueblos cercanos en la frecuencia de los 94.3 FM, con una variedad de música y programas hablados.
          </li>
          <li>
            <strong>Noble 94 FM Digital:</strong> Transmitiendo a través de la plataforma de internet para todo el planeta, con una programación variada y con contenido histórico de Vicente Noble y el sur.
          </li>
          <li>
            <strong>Radio Plenitud Total:</strong> Transmitiendo a través de la plataforma de internet para todo el planeta, con una programación de contenido cristiano y de alabanza a Dios.
          </li>
          <li>
            <strong>Periódico Noble Digital:</strong> Periódico de noticias y opiniones que informa sobre la República Dominicana y el municipio de Vicente Noble, además de abordar temas de tecnología y opiniones de nuestros editorialistas.
          </li>
        </ul>

        <p>
          Nuestra ubicación se encuentra en el centro del municipio de Vicente Noble y para más información, puede contactarnos a través de los correos electrónicos:{" "}
          <a href="mailto:noble94fm@gmail.com">noble94fm@gmail.com</a> y{" "}
          <a href="mailto:radioplenitudtotal@gmail.com">radioplenitudtotal@gmail.com</a>. Estamos comprometidos en llevar información, alegría y paz a todo el planeta, y en conectar a los ciudadanos de Vicente Noble con sus compatriotas en la República Dominicana.
        </p>
      </div>
    </aside>
  );
};

export default AboutUs;
